import { MouseEvent, useState } from 'react';

export default function useMenu() {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const handleOpen = (event: MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return {
		anchorEl,
		open: Boolean(anchorEl),
		handleOpen,
		handleClose,
	};
}
